export const GRADIENT_LENGTH = 99;

export const STEPS = [900, 800, 700, 600, 500, 400, 300, 200, 100];

export const SWATCH_SIZE = 40;
